var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3431 5.89774H10.5784V4.26138C10.5784 2.0032 8.86549 0.170471 6.7549 0.170471C4.64432 0.170471 2.93137 2.0032 2.93137 4.26138V5.89774H2.16667C1.32167 5.89774 0.637257 6.63002 0.637257 7.53411V15.7159C0.637257 16.62 1.32167 17.3523 2.16667 17.3523H11.3431C12.1881 17.3523 12.8726 16.62 12.8726 15.7159V7.53411C12.8726 6.63002 12.1881 5.89774 11.3431 5.89774ZM6.7549 13.2614C5.9099 13.2614 5.22549 12.5291 5.22549 11.625C5.22549 10.7209 5.9099 9.98865 6.7549 9.98865C7.5999 9.98865 8.28432 10.7209 8.28432 11.625C8.28432 12.5291 7.5999 13.2614 6.7549 13.2614ZM9.12549 5.89774H4.38432V4.26138C4.38432 2.86229 5.44726 1.72502 6.7549 1.72502C8.06255 1.72502 9.12549 2.86229 9.12549 4.26138V5.89774Z",
    fill: "#CDCEC8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.9eb00f18.svg";
export { ForwardRef as ReactComponent };